import styles from "./Navbar.module.css";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import test from "@assets/test.svg";
import { useNavigate } from "react-router";
import useAuth from "@hooks/useAuth";

const Navbar = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { handleLogoutSession } = useAuth();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNavigateHome = () => {
    navigate("/");
  };

  const handleLogoutClick = () => {
    handleLogoutSession();
    handleClose();
  };

  return (
    <div className={styles.Wrapper}>
      <img
        src={test}
        alt="orbsway"
        className={styles.Logo}
        onClick={handleNavigateHome}
      />

      <AccountCircleIcon
        className={styles.ProfileIcon}
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      />
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={handleLogoutClick}>Logout</MenuItem>
      </Menu>
    </div>
  );
};

export default Navbar;
